import TurfBuffer from '@turf/buffer';
import {multiLine2Line} from "../utils/functions";

class LayerRoad {
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentRoad = false;
		this.currentRoadIdx = false;
		
	}
	
//	
//	
//	placeRoads(){
//		
//		var lines = structuredClone(this.scenario.roads);	
//		
//		var data = {
//			"type":"FeatureCollection",
//			"features":[]
//		};
//		
//		const buffers = [];
//		
//		data.features = lines.map((f)=>{
//			f.type = 'Feature';
//			f.properties = {...f.properties};
//			f.properties.width = f.width ? f.width : LayerRoad.defaultWidth;
//			f.properties.color = f.color ? f.color : LayerRoad.defaultColor;
//			
//			if(f.properties && f.properties.tempid)
//				f.id = f.properties.tempid;
//			else
//				f.id = f.roadid;
//			
//			if(f.geometry){
//				var buff = TurfBuffer(f, f.properties.width/2, { units: 'meters' });
//				buff.bufferid = f.id;
//				buff.id = 100000000+f.id;
//				buff.properties.roadid = f.id;
//				buffers.push(buff);		
//			}
//			return f;
//		});
//		
//		data.features.push(...buffers);
//		
//		if(this.map.getLayer(LayerRoad.outlineId)){
//			this.map.removeLayer(LayerRoad.outlineId);
//			this.map.removeLayer(LayerRoad.fillId);
//			this.map.removeLayer(LayerRoad.bufferId);
//			this.map.removeSource(LayerRoad.sourceId);
//		}
//
//		if(!this.map.getSource(LayerRoad.sourceId	))
//			this.map.addSource(LayerRoad.sourceId	, {
//				'type': 'geojson',
//				'data': data
//			});
//		
//		this.map.addLayer({
//			'id': LayerRoad.bufferId,
//			'type': 'fill',
//			'source': LayerRoad.sourceId	, // reference the data source
//			'layout': {
//				'visibility' : this.map.layerStatus['rd_layer'] ? 'visible' : 'none',
//			},
//			'paint': {
//				'fill-color': "#000000",
//				'fill-opacity': ['case',
//					['boolean', ['feature-state', 'invisible'], false],0,
//					['boolean', ['feature-state', 'hover'], false],1,
//					['boolean', ['feature-state', 'selected'], false],.3,
//					.3
//				]
//			},
//			'filter': ['==', '$type', 'Polygon']
//		});	
//		[
//			[LayerRoad.outlineId, 6, "#000000"],
//			[LayerRoad.fillId, 3, "#ffffff"],
//		].forEach((layer)=>{
//			this.map.addLayer({
//				'id': layer[0],
//				'type': 'line',
//				'source': LayerRoad.sourceId, // reference the data source
//				'layout': {
//					'visibility' : this.map.layerStatus['rd_layer'] ? 'visible' : 'none',
//					"line-cap": "square"
//				},
//				'paint': {
//					'line-color': layer[2],
//					'line-width': layer[1],
//					'line-opacity': ['case',
//						['boolean', ['feature-state', 'invisible'], false],0,
//						1
//					]
//				},
//				'filter': ['==', '$type', 'LineString']
//			});			
//			
//		});
//	}

	json(){
		
		var lines = structuredClone(this.tc.scenario.roads);
		
		const l = {
			source: {
				'id': LayerRoad.sourceId,
				'type': 'geojson',
				'data': {
					"type":"FeatureCollection",
					"features":[]
				}
			}
		};
		const buffers = [];
		
		l.source.data.features = lines.map((f)=>{
			multiLine2Line(f);
			f.type = 'Feature';
			f.properties = {...f.properties};
			f.properties.width = f.width ? f.width : LayerRoad.defaultWidth;
			f.properties.color = f.color ? f.color : LayerRoad.defaultColor;
			
			if(f.properties && f.properties.tempid)
				f.id = f.properties.tempid;
			else
				f.id = f.roadid;
			
			if(f.geometry && f.geometry.coordinates && f.geometry.coordinates.length){
				var buff = TurfBuffer(f, f.properties.width/2, { units: 'meters' });
				buff.bufferid = f.id;
				buff.id = 100000000+f.id;
				buff.properties.roadid = f.id;
				buffers.push(buff);		
			}
			return f;
		});
		l.source.data.features.push(...buffers);
		
		// Add a new layer to visualize the polygon.
		l.layer = [
			{
				'id': LayerRoad.bufferId,
				'type': 'fill',
				'source': LayerRoad.sourceId, 
				'paint': {
					'fill-color': "#000000",
					'fill-opacity': ['case',
						['boolean', ['feature-state', 'invisible'], false],0,
						['boolean', ['feature-state', 'hover'], false],1,
						['boolean', ['feature-state', 'selected'], false],.3,
						.3
					]
				},
				'filter': ['==', '$type', 'Polygon']
			}
		];
		
		[
			[LayerRoad.outlineId, 6, "#000000"],
			[LayerRoad.fillId, 3, "#ffffff"],
		].forEach((layer)=>{
			l.layer.push({
				'id': layer[0],
				'type': 'line',
				'source': LayerRoad.sourceId, // reference the data source
				'layout': {
					"line-cap": "square"
				},
				'paint': {
					'line-color': layer[2],
					'line-width': layer[1],
					'line-opacity': ['case',
						['boolean', ['feature-state', 'invisible'], false],0,
						1
					]
				},
				'filter': ['==', '$type', 'LineString']
			});			
			
		});
		
		
		return l;
	}
	
}

LayerRoad.fillId			= 'rd_layer_fl';
LayerRoad.outlineId			= 'rd_layer_ol';
LayerRoad.bufferId			= 'rd_layer_buff';
LayerRoad.handlesId			= 'road_handle_circles';
LayerRoad.sourceId			= 'rd_source';
LayerRoad.defaultWidth		= 6;
LayerRoad.defaultColor		= "#000000";
LayerRoad.layers			= [
	{id: LayerRoad.fillId },
	{id: LayerRoad.outlineId },
	{id: LayerRoad.bufferId },
]


export default LayerRoad;